import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Card,
  CardContent,
  IconButton,
  useMediaQuery,
  CardHeader,
  Container,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TablePagination,
  OutlinedInput,
  InputAdornment,
  SvgIcon,
  Pagination,
  Skeleton,
  Alert,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Link, useNavigate } from "react-router-dom";
import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
import MagnifyingGlassIcon from "@heroicons/react/24/solid/MagnifyingGlassIcon";
import { DeleteJozve, ListJozveStudent } from "Services/Student";
import { Alert as Notif } from "utils/alerts";
import { Confirm } from "utils/alerts";
import jalaali from "jalaali-js";
import { useTranslation } from "react-i18next";

const itemsPerPage = 5; // Adjust the number of items per page

const convertToShamsi = (gregorianDateStr) => {
  const date = new Date(gregorianDateStr);
  const j = jalaali.toJalaali(date);
  return `${j.jy}/${j.jm.toString().padStart(2, "0")}/${j.jd
    .toString()
    .padStart(2, "0")}`;
};
const File = () => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const navigate = useNavigate(); // Initialize navigate
  const [cardPage, setCardPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  // Calculate total pages
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const [data, setData] = useState([]);
  const fetchData = async () => {
    setIsLoading(true); // <-- Add this line
    try {
      const response = await ListJozveStudent();
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false); // <-- Always turn off loading state
  };

  useEffect(() => {
    fetchData();
  }, []); // Runs when userType changes

  // @ts-ignore

  // Filtered data based on searchQuery
  const filteredData = data.filter(
    (row) =>
      (row?.codejozve?.toString() || "").includes(searchQuery) ||
      (row?.teachername?.toString() || "").includes(searchQuery) ||
      (row?.namejozve?.toLowerCase() || "").includes(searchQuery.toLowerCase())
  );

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleEdit = (idstrjozve) => {
    navigate(`/${i18n.language}/file/addfile?id=${idstrjozve}`);
  };

  const handleDelete = async (idstrjozve) => {
    const { value } = await Confirm(
      t("fileSection.deleteTitle"),
      t("fileSection.deleteConfirm"),
      t("newFile.editDialogConfirm"),
      t("newFile.editDialogCancel"),
      "question"
    );
    if (value) {
      try {
        await DeleteJozve(idstrjozve);
        fetchData(); // Refresh the data after successful deletion
        Notif(
          t("fileSection.deleteTitle"),
          t("fileSection.deleteSuccess"),
          "success"
        );
      } catch (error) {
        Notif(t("fileSection.error"), error?.response?.data);
      }
    }
  };

  const handleAlertClick = (row) => {
    if (getStatusSeverity(row.isvalidation, row.commentadmin) === "error") {
      setSelectedRow(row);
      setOpenModal(true); // Open modal if error status
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false); // Close modal
    setSelectedRow(null); // Clear selected row
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Function to map status to Alert severity
  const getStatusSeverity = (isValidation, adminComment) => {
    if (isValidation === true) {
      return "success";
    } else if (isValidation === false && !adminComment) {
      return "warning";
    } else if (isValidation === false && adminComment) {
      return "error";
    }
    return "info";
  };

  // Function to get status text
  const getStatusText = (isValidation, adminComment) => {
    if (isValidation === true) {
      return t("Note.confrimed");
    } else if (isValidation === false && !adminComment) {
      return t("Note.pending");
    } else if (isValidation === false && adminComment) {
      return t("Note.rejected");
    }
    return "نامشخص";
  };
  const getAlertBackground = (row) => {
    const status = getStatusSeverity(row.isvalidation, row.commentadmin);
    switch (status) {
      case "success":
        return "#dcfce7"; // pale green
      case "warning":
        return "#fef9c3"; // pale yellow
      case "error":
        return "#fee2e2"; // pale red
      default:
        return "#f1f5f9"; // neutral
    }
  };

  const getAlertTextColor = (row) => {
    const status = getStatusSeverity(row.isvalidation, row.commentadmin);
    switch (status) {
      case "success":
        return "#166534";
      case "warning":
        return "#92400e";
      case "error":
        return "#e62525";
      default:
        return "#334155";
    }
  };

  const getAlertBorderColor = (row) => {
    const status = getStatusSeverity(row.isvalidation, row.commentadmin);
    switch (status) {
      case "success":
        return "#bbf7d0";
      case "warning":
        return "#fde68a";
      case "error":
        return "#fecaca";
      default:
        return "#cbd5e1";
    }
  };

  // Function to map severity to custom styles
  const getAlertStyles = (severity) => {
    switch (severity) {
      case "success":
        return {
          backgroundColor: "#d4edda",
          color: "#155724",
          border: "1px solid #c3e6cb",
        };
      case "warning":
        return {
          backgroundColor: "#fff3cd",
          color: "#856404",
          border: "1px solid #ffeeba",
        };
      case "error":
        return {
          backgroundColor: "#f8d7da",
          color: "#721c24",
          border: "1px solid #f5c6cb",
        };
      default:
        return {};
    }
  };
  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Get current page data
  const cardPaginatedData = data.slice(
    (cardPage - 1) * itemsPerPage,
    cardPage * itemsPerPage
  );
  const handleCardPageChange = (event, value) => {
    setCardPage(value);
  };
  return (
    <Container sx={{ p: 2 }}>
      <Card>
        <CardHeader
          title={t("Note.title")}
          action={
            <Link to={`/${lang}/file/addfile`}>
              <IconButton>
                <Tooltip
                  title={t("fileSection.addFileTooltip", "افزودن فایل جدید")}
                  placement="top"
                  arrow
                >
                  <AddIcon fontSize="large" color="success" />
                </Tooltip>
              </IconButton>
            </Link>
          }
        />
        <OutlinedInput
          onChange={handleSearch}
          defaultValue=""
          fullWidth
          placeholder={t("Note.search")}
          startAdornment={
            <InputAdornment position="start">
              <SvgIcon>
                <MagnifyingGlassIcon />
              </SvgIcon>
            </InputAdornment>
          }
          sx={{ width: { xs: "90%", md: "50%" }, ml: 1 }}
        />
        <CardContent>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            {isMobile ? (
              <Box>
                {isLoading ? (
                  [...Array(itemsPerPage)].map((_, index) => (
                    <Card
                      key={index}
                      sx={{ mb: 2, border: "1px solid #A8A8A8" }}
                    >
                      <CardContent
                        sx={{
                          padding: "15px 20px 10px",
                          pb: "0!important",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <Skeleton variant="text" width="40%" />
                        <Skeleton variant="text" width="70%" />
                        <Skeleton
                          variant="rectangular"
                          height={30}
                          sx={{ mt: 1 }}
                        />
                      </CardContent>
                    </Card>
                  ))
                ) : cardPaginatedData.length > 0 ? (
                  cardPaginatedData.map((row) => (
                    <Card
                      key={row.idstrjozve}
                      sx={{
                        mb: 2,
                        borderRadius: 3,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                        border: "1px solid #e2e8f0",
                        transition: "0.3s ease",
                        backgroundColor: "#fff",
                        "&:hover": {
                          boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
                          transform: "translateY(-3px)",
                        },
                      }}
                    >
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 4,
                          p: 3,
                        }}
                      >
                        {/* Top Section: Code + Status */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              fontWeight={600}
                              color="#1e293b"
                            >
                              {t("Note.id")}: {row.codejozve}
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              fontWeight={500}
                              color="#1e293b"
                            >
                              {convertToShamsi(row.datesabt)}
                            </Typography>
                          </Box>

                          <Alert
                            icon={false}
                            severity={getStatusSeverity(
                              row.isvalidation,
                              row.commentadmin
                            )}
                            sx={{
                              px: 2,
                              py: 0.5,
                              borderRadius: 2,
                              fontWeight: 500,
                              fontSize: "13px",
                              textAlign: "center",
                              height: "30px",
                              display: "flex",
                              alignItems: "center",
                              backgroundColor: getAlertBackground(row),
                              color: getAlertTextColor(row),
                              border: "1px solid",
                              borderColor: getAlertBorderColor(row),
                            }}
                            onClick={() => {
                              if (
                                getStatusSeverity(
                                  row.isvalidation,
                                  row.commentadmin
                                ) === "error"
                              ) {
                                handleAlertClick(row);
                              }
                            }}
                          >
                            {getStatusText(row.isvalidation, row.commentadmin)}
                          </Alert>
                        </Box>

                        {/* File Name and Additional Fields */}
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                          }}
                        >
                          <Typography variant="body1" color="#475569">
                            {t("Note.name")}:{" "}
                            <a
                              href={row.pathjozve}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="underline text-blue-600 hover:text-blue-800"
                              style={{ fontWeight: 500 }}
                            >
                              {row.namejozve}
                            </a>
                          </Typography>
                          <Typography variant="body1" color="#475569">
                            {t("Note.professor")}{" "}
                            <span style={{ fontWeight: 500 }}>
                              {row.teachername}
                            </span>
                          </Typography>
                          <Typography variant="body1" color="#475569">
                            {t("Note.price")}:
                            <span style={{ fontWeight: 500 }}>
                              {row.price} {t("Note.currency")}
                            </span>
                          </Typography>
                          <Typography variant="body1" color="#475569">
                            {t("Note.profit")}:{" "}
                            <span style={{ fontWeight: 500 }}>
                              {row.priceTotalSood} {t("Note.currency")}
                            </span>
                          </Typography>
                        </Box>

                        {/* Actions */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 1.5,
                          }}
                        >
                          <Tooltip
                            title={t("fileSection.edit", "ویرایش")}
                            arrow
                          >
                            <IconButton
                              onClick={() => handleEdit(row.idstrjozve)}
                              sx={{
                                backgroundColor: "#fef3c7", // soft yellow
                                color: "#f06f1f",
                                "&:hover": {
                                  backgroundColor: "#fde68a",
                                },
                              }}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title={t("fileSection.delete", "حذف")} arrow>
                            <IconButton
                              onClick={() => handleDelete(row.idstrjozve)}
                              sx={{
                                backgroundColor: "#fee2e2", // soft red
                                color: "#e62525",
                                "&:hover": {
                                  backgroundColor: "#fecaca",
                                },
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </CardContent>
                    </Card>
                  ))
                ) : (
                  <Typography variant="body1" textAlign="center">
                    {t("fileSection.noFiles")}
                  </Typography>
                )}

                {/* MUI Pagination */}
                <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                  <Pagination
                    count={totalPages}
                    page={cardPage}
                    onChange={handleCardPageChange}
                  />
                </Box>
              </Box>
            ) : (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("Note.id")}</TableCell>
                      <TableCell>{t("Note.name")}</TableCell>
                      <TableCell> {t("Note.professor")}</TableCell>{" "}
                      {/* Added teachername column */}
                      <TableCell>
                        {" "}
                        {t("Note.price")} {t("Note.currency")}{" "}
                      </TableCell>{" "}
                      {/* Added price column */}
                      <TableCell>
                        {t("Note.profit")} {t("Note.currency")}{" "}
                      </TableCell>{" "}
                      {/* Added priceTotalSood column */}
                      <TableCell style={{ width: "100px" }}>
                        {t("Note.date")}
                      </TableCell>
                      <TableCell style={{ width: "100px" }}>
                        {t("Note.status")}{" "}
                      </TableCell>
                      <TableCell align="right" style={{ width: "100px" }}>
                        {t("Note.action")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {isLoading ? (
                      [...Array(rowsPerPage)].map((_, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <Skeleton variant="text" />
                          </TableCell>
                          <TableCell>
                            <Skeleton variant="text" />
                          </TableCell>
                          <TableCell>
                            <Skeleton variant="text" />
                          </TableCell>
                          <TableCell>
                            <Skeleton variant="text" />
                          </TableCell>
                          <TableCell>
                            <Skeleton variant="text" />
                          </TableCell>
                          <TableCell>
                            <Skeleton variant="rectangular" height={30} />
                          </TableCell>
                          <TableCell align="right">
                            <Skeleton
                              variant="circular"
                              width={30}
                              height={30}
                            />
                          </TableCell>
                        </TableRow>
                      ))
                    ) : paginatedData.length > 0 ? (
                      paginatedData.map((row) => (
                        <TableRow key={row.idstrjozve}>
                          <TableCell>{row.codejozve}</TableCell>
                          <TableCell sx={{ textDecoration: "underline" }}>
                            <a
                              href={row.pathjozve}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {row.namejozve}
                            </a>
                          </TableCell>
                          <TableCell>{row.teachername}</TableCell>{" "}
                          {/* Display teachername */}
                          <TableCell>
                            {(row.price / 10).toLocaleString()}
                          </TableCell>{" "}
                          {/* Display price */}
                          <TableCell>
                            {(row.priceTotalSood / 10).toLocaleString()}
                          </TableCell>{" "}
                          {/* Display priceTotalSood */}
                          <TableCell>{convertToShamsi(row.datesabt)}</TableCell>
                          <TableCell align="center">
                            <Alert
                              icon={
                                getStatusSeverity(
                                  row.isvalidation,
                                  row.commentadmin
                                ) === "error"
                                  ? undefined
                                  : false
                              }
                              severity={getStatusSeverity(
                                row.isvalidation,
                                row.commentadmin
                              )}
                              sx={{
                                ...getAlertStyles(
                                  getStatusSeverity(
                                    row.isvalidation,
                                    row.commentadmin
                                  )
                                ),
                                fontSize: "14px",
                                fontWeight: "bold",
                                borderRadius: "8px",
                                px: 2,
                                py: 0.5,
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                ...(getStatusSeverity(
                                  row.isvalidation,
                                  row.commentadmin
                                ) === "error" && {
                                  cursor: "pointer",
                                }),
                              }}
                              onClick={() => {
                                if (
                                  getStatusSeverity(
                                    row.isvalidation,
                                    row.commentadmin
                                  ) === "error"
                                ) {
                                  handleAlertClick(row);
                                }
                              }}
                            >
                              {getStatusText(
                                row.isvalidation,
                                row.commentadmin
                              )}
                            </Alert>
                          </TableCell>
                          <TableCell align="right">
                            <IconButton
                              color="warning"
                              aria-label="edit"
                              onClick={() => handleEdit(row.idstrjozve)}
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              color="error"
                              aria-label="delete"
                              onClick={() => handleDelete(row.idstrjozve)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={8} align="center">
                          {t("fileSection.noFiles")}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        </CardContent>
      </Card>

      {/* Modal (Dialog) for Error Alerts */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {t("fileSection.dialogTitle", { code: selectedRow?.codejozve })}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">{selectedRow?.commentadmin}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            {t("fileSection.close", "بستن")}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};
export default File;
